import { FormAddress } from '@/models/common/address';
import { LocationModel } from '@/models/common/location';
import { TimeHelper } from '@/helpers/TimeHelper';

class OrganisationModel {
  id;
  createdOn;
  name;
  email;
  phone;
  address;
  shippingAddress;
  orgContact;
  location;
  status;
  defaults;

  region;
  contractStart;
  contractEnd;
  diagnosticScriptName;
  appSubscriptions;
  invoiceNumber;
  katanaOrderNumber;
  shipmentNumber;
  contractTermMonths;
  accountManager;
  comments;

  constructor(data) {
    this.populate(data || {});
  }

  get dateCreated() {
    return TimeHelper.formatDate(this.createdOn);
  }

  populate(data) {
    this.id = data.id || null;
    this.createdOn = data.createdOn || null;
    this.name = data.name || '';
    this.status = data.status || '';
    this.email = data.email || '';
    this.phone = data.phone || '';
    this.address = new FormAddress(data.address || null);
    this.shippingAddress = new FormAddress(data.shippingAddress || null);
    this.orgContact = data.orgContact || {};
    this.location = new LocationModel(data.location || null);
    this.defaults = data.defaults || null;

    this.region = data.region || '';
    this.contractStart = data.contractStart ? new Date(data.contractStart) : null;
    this.contractEnd = data.contractEnd ? new Date(data.contractEnd) : null;
    this.diagnosticScriptName = data.diagnosticScriptName || '';
    this.appSubscriptions = data.appSubscriptions || null;
    this.invoiceNumber = data.invoiceNumber || [];
    this.shipmentNumber = data.shipmentNumber || [];
    this.katanaOrderNumber = data.katanaOrderNumber || [];
    this.contractTermMonths = data.contractTermMonths || null;
    this.accountManager = data.accountManager || {};
    this.comments = data.comments || '';
  }

  toDetailsUpdateJson(originalData) {
    let output = {};
    if (this.name !== originalData.name) output.name = this.name;
    if (this.phone !== originalData.phone) output.phone = this.phone;
    if (this.email !== originalData.email) output.email = this.email;
    if (this.status !== originalData.status) output.status = this.status;
    output.address = this.address;
    output.shippingAddress = this.shippingAddress;
    output.contactId = this.orgContact.id;

    output.region = this.region;
    output.contractStart = this.contractStart;
    output.contractEnd = this.contractEnd;
    output.diagnosticScriptName = this.diagnosticScriptName;
    output.appSubscriptions = +this.appSubscriptions;
    output.invoiceNumber = this.invoiceNumber;
    output.shipmentNumber = this.shipmentNumber;
    output.katanaOrderNumber = this.katanaOrderNumber;
    output.contractTermMonths = +this.contractTermMonths;
    output.accountManagerId = this.accountManager.id;
    output.comments = this.comments;

    return output; // TODO first check if object is empty
  }

  exportToCreate(data) {
    return {
      name: this.name,
      email: this.email,
      contactId: this.orgContact.id,
      phone: this.phone,
      address: this.address,
      shippingAddress: this.shippingAddress,
      defaults: data.defaults ? data.defaults : this.defaults
    };
  }
}

export { OrganisationModel };
